import { IntegrationSources } from 'Shared/constants/IntegrationsList.constants';

export { IntegrationSources };

export enum UpdateAiTemplateTypeType {
  SALES = 'sales',
  PROJECT = 'project',
}

export type UpdateAiTemplateSectionType = {
  slug: string;
  title: string;
  active: boolean;
  description: string;
  position: number;
  iconName?: string;
  improvements?: Array<string>;
};

export type UpdateAiTemplateType = {
  slug: string;
  name: string;
  description?: string;
  templateType: UpdateAiTemplateTypeType;
  public: boolean;
  defaultTemplate: boolean;
  defaultDataSourceSlugs: IntegrationSources[];
  updateAiTemplateSections: UpdateAiTemplateSectionType[];
};
